export const DOUBLE_BRACE_TOKENS = ()=>/\{\{([^}]+)\}\}/g;
export function tokenRanges(text) {
    let pattern = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DOUBLE_BRACE_TOKENS;
    return [
        ...text.matchAll(pattern())
    ].map((match)=>({
            start: match.index,
            end: match.index + match[0].length,
            label: match[1].trim()
        }));
}
export function tokenAtOffset(args) {
    const { text, offset, pattern } = args;
    return tokenRanges(text, pattern).find((param)=>{
        let { start, end } = param;
        return offset >= start && offset < end;
    });
}
export function tokenText(label) {
    return "{{".concat(label, "}}");
}
export function spliceToken(args) {
    const { text, label, selectionStart, selectionEnd } = args;
    const inserted = tokenText(label);
    return {
        value: text.slice(0, selectionStart) + inserted + text.slice(selectionEnd),
        caret: selectionStart + inserted.length
    };
}
export function toTokenSegments(args) {
    const { text, pattern, resolve, isUnfilled } = args;
    const segments = [];
    let lastIndex = 0;
    for (const { start, end, label } of tokenRanges(text, pattern)){
        var _ref;
        if (start > lastIndex) segments.push({
            type: 'text',
            value: text.slice(lastIndex, start)
        });
        const resolved = resolve === null || resolve === void 0 ? void 0 : resolve(label);
        segments.push(resolved != null ? {
            type: 'resolved',
            value: resolved
        } : {
            type: 'token',
            label,
            unfilled: (_ref = isUnfilled === null || isUnfilled === void 0 ? void 0 : isUnfilled(label)) !== null && _ref !== void 0 ? _ref : false
        });
        lastIndex = end;
    }
    if (lastIndex < text.length) segments.push({
        type: 'text',
        value: text.slice(lastIndex)
    });
    return segments;
}
const TRIGGER_KEY = '{';
function caretIntentWithinToken(args) {
    const { token, key, caret, selectionStart, selectionEnd, shiftKey, modifierKey } = args;
    const { start, end } = token;
    if (key === 'ArrowRight' && caret < end) {
        return shiftKey ? {
            type: 'select',
            start: selectionStart,
            end,
            direction: 'forward'
        } : {
            type: 'moveCaret',
            to: end
        };
    }
    if (key === 'ArrowLeft' && caret > start) {
        return shiftKey ? {
            type: 'select',
            start,
            end: selectionEnd,
            direction: 'backward'
        } : {
            type: 'moveCaret',
            to: start
        };
    }
    if (key === 'Backspace' && caret > start) return {
        type: 'select',
        start,
        end
    };
    if (key === 'Delete' && caret < end) return {
        type: 'select',
        start,
        end
    };
    if (key.length === 1 && !modifierKey && caret > start && caret < end) return {
        type: 'swallow'
    };
    return undefined;
}
function triggerIntent(text, caret) {
    if (text[caret - 1] !== TRIGGER_KEY) return undefined;
    return {
        type: 'openTrigger',
        at: caret - 1,
        textWithoutBrace: text.slice(0, caret - 1) + text.slice(caret)
    };
}
export function tokenKeyIntent(args) {
    const { text, key, selectionStart, selectionEnd, shiftKey, modifierKey, pattern } = args;
    const isDeletion = key === 'Backspace' || key === 'Delete';
    // WHY: an existing selection already spans the token to delete — re-scanning re-selects the preceding token at the shared {{a}}{{b}} boundary (ANCR-2211)
    if (isDeletion && selectionStart !== selectionEnd) return undefined;
    const caret = selectionStart;
    const touchedTokens = tokenRanges(text, pattern).filter((param)=>{
        let { start, end } = param;
        return caret >= start && caret <= end;
    });
    for (const token of touchedTokens){
        const intent = caretIntentWithinToken({
            token,
            key,
            caret,
            selectionStart,
            selectionEnd,
            shiftKey,
            modifierKey
        });
        if (intent) return intent;
    }
    return key === TRIGGER_KEY ? triggerIntent(text, caret) : undefined;
}
